import React, { Fragment } from 'react';
import { IExampleNavLink } from './types';
/**
 * When use this component in test pages, make sure to add to styles:
 * body {
 *   padding-top: 70px;
 *   padding-bottom: 20px;
 * }
 */

/**
 * Renders basic page layout with optional navigation.
 * Uses bootstrap classes
 */
export class ExampleLayout extends React.Component<React.PropsWithChildren<{ navData?: IExampleNavLink[] }>, {}> {
  public render() {
    const links = this.props.navData
      ? this.props.navData.map((item: IExampleNavLink, i) => {
          return (
            <li key={i} className={item.isActive ? 'active' : ''}>
              <a href={item.url}>{item.label}</a>
            </li>
          );
        })
      : '';
    return (
      <Fragment>
        <nav className="navbar navbar-default navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-header">
              <span className="navbar-brand">HL</span>
            </div>
            <div className="collapse navbar-collapse">
              <ul className="nav navbar-nav">{links}</ul>
            </div>
          </div>
        </nav>
        <div className="container-fluid">{this.props.children}</div>
      </Fragment>
    );
  }
}

export default ExampleLayout;
